import React from "react";
import StartWorkOut from "./StartWorkOutBtn";

function WorkOutIndex(prop) {
  //const bodyPart = ["back", "chest", "cardio", "lower arms", "lower legs", "neck", "shoulders", "upper arms", "upper legs", "waist"]
  return (
    <section id="select_workout-container" className="bg-cover">
      <div className="flex flex-col h-screen items-center justify-center">
        {/* {bodyPart.map((element) => (
          <div className="flex justify-center items-center h-1/5 bg-back-image bg-center bg-cover bg-no-repeat my-1 w-11/12 rounded">
            <div className="flex justify-center items-center backdrop-blur-sm bg-black/10 w-full h-full">
              <div key={bodyPart.indexOf(element)}>
                <h2 className="text-white capitalize font-bold">
                  {element} Workouts
                </h2>
              </div>
            </div>
          </div>
        ))} */}
        <div>
          <StartWorkOut {...prop} />
        </div>
        <div className="text-center">
          <p className="text-center text-xl italic my-2">
            "If something stands between you and your success,
            <br /> move it, never be denied"
          </p>
          <p className="font-bold">Dwayne "The Rock" Johnson</p>
        </div>
      </div>
    </section>
  );
}

export default WorkOutIndex;
